import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icones/icones-questnova-home.png")